import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import DepartmentFilterSource from 'sources/DepartmentFilterSource';

class DepartmentFilterActions {
  constructor() {
    this.generateActions(
      'toggleDepartment',
      'selectAll',
      'resetIds',
      ...generateAsyncActions('fetchAllDepartments')
    );
  }

  /**
   * Populate the department filter store with auth user's available departments
   */
  fetchAllDepartments(overwriteCookie = false) {
    return dispatch => {
      dispatch();
      return DepartmentFilterSource.fetchAllDepartments(overwriteCookie).then(
        this.fetchAllDepartmentsSuccess,
        this.fetchAllDepartmentsError
      );
    };
  }
}

export default alt.createActions(DepartmentFilterActions);
